module.exports = __webpack_public_path__ + "static/img/kaifa.19ddc0e9.png";